
export const GlobalGtmEventHelper = () => ({
  bindGlobalGtmEvent: (selector, callback) => {
    document.querySelector('body').addEventListener('click', function(evt) {
      if (evt.target.matches(selector)) {
        callback(evt.target);
      }
    }, true); // Use Capturing
  }
});

export default GlobalGtmEventHelper;
